import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { UserService } from '@services/user.service';
import { ProviderType } from '@enums/provider-type.enum';
import { AuthService } from '@services/auth.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-upload-form',
    templateUrl: './upload-form.component.html',
    styleUrls: ['./upload-form.component.scss']
})
export class UploadFormComponent implements OnInit, OnDestroy {
    @Output() newTabIndex = new EventEmitter<number>();

    private userParamSub: Subscription;
    doesShowProviders: boolean;
    roleUser: any;
    provider: ProviderType;

    constructor(
        private userSrv: UserService,
        private authSrv: AuthService
    ) {
        this.roleUser = this.authSrv.getAuthUser().role;
        this.provider = this.authSrv.getDecodedToken().provider_category;
    }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.userParamSub = this.userSrv.userParametersSubject
        .subscribe(() => {
            this.doesShowProviders = true;
        });
    }

    ngOnDestroy(): void {
        if(this.userParamSub) {
            this.userParamSub.unsubscribe();
        }
    }

    tabSelected(event: MatTabChangeEvent): void {
        this.newTabIndex.emit(event.index);
    }
}
